import CONSTANTS from '../constants'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	loaderSms: false,
	loaderDownload: false,
	hasError: false,
	data: EMPTY_ARRAY,
	faclityData: EMPTY_OBJECT,
	errorMessage: '',
	smsResponse: '',
	downloadResponse: '',
	ticketDetails: EMPTY_OBJECT,
}

const userDetailsReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case CONSTANTS.GET_TICKET_LIST_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: null
			}

		case CONSTANTS.GET_TICKET_LIST_SUCCESS:
			return {
				...state,
				loader: false,
				ticketDetails: action?.data,
				hasError: false,
				errorMessage: null
			}
		case CONSTANTS.GET_TICKET_LIST_FAILURE:
			return {
				...state,
				loader: false,
				ticketDetails: null,
				hasError: true,
				errorMessage: action?.errorMessage
			}
		case CONSTANTS.DOWNLOAD_TICKET_REQUEST:
			return {
				...state,
				loaderDownload: true,
				errorMessage: ''
			}

		case CONSTANTS.DOWNLOAD_TICKET_SUCCESS:
			return {
				...state,
				loaderDownload: false,
				downloadResponse: action?.data,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.DOWNLOAD_TICKET_FAILURE:
			return {
				...state,
				loaderDownload: false,
				downloadResponse: '',
				errorMessage: 'There is some Error'
			}

			case CONSTANTS.GET_TICKET_DETAILS_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: null
			}

		case CONSTANTS.GET_TICKET_DETAILS_SUCCESS:
			return {
				...state,
				loader: false,
				ticketDetails: action?.data,
				hasError: false,
				errorMessage: null
			}
		case CONSTANTS.GET_TICKET_DETAILS_FAILURE:
			return {
				...state,
				loader: false,
				ticketDetails: null,
				hasError: true,
				errorMessage: action?.errorMessage
			}	
		default:
			return state
	}
}

export default userDetailsReducer
